import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { OperationLogsGetResponse } from "@/types/swagger";
import API from "@/api";
import Utils from "@/common/utils";

export interface IOperationLogsState {
  timestamp: string; // 操作日時 ex. 2014年10月10日 13:50:40
  user_name: string; // 操作者
  screen_name: string; // 操作画面
  operation_name: string; // 利用機能種別
}

export interface IPostOperationLogsParameters {
  user_id: number;
  operation_class: number;
}

export interface IPostOperationLogsNonAuthParameters {
  email: string;
  operation_class: number;
}

export interface IGetOperationLogsParameters {
  user_id: number;
  target_year_month: string; // 対象年月度（yyyyMM）ex. 202011
}

const initialState: IOperationLogsState[] = [];

@Module({
  name: "OperationLogs",
  stateFactory: true,
  namespaced: true,
})
export class OperationLogs extends VuexModule {
  public operationLogs: IOperationLogsState[] = initialState;

  public static OPERATION_CLASS = {
    LOGIN: 0, // ログイン
    PASSWORD_RESET: 1, // パスワード初期化
    DOWNLOAD_FSM_CSV: 2, // 施設基準管理システム連携用CSVダウンロード
  };

  public get getOperationLogs(): IOperationLogsState[] {
    return this.operationLogs;
  }

  @Mutation set(operationLogs: IOperationLogsState[]) {
    this.operationLogs = operationLogs;
  }

  @Action({ rawError: true })
  public init() {
    this.set(initialState);
  }

  @Action({ rawError: true })
  public async recordOperationLogs(params: IPostOperationLogsParameters) {
    const api = new API();
    await api.post(`/users/${params.user_id}/operation/logs`, {
      body: {
        operation_class: params.operation_class,
      },
    });
  }

  @Action({ rawError: true })
  public async recordOperationLogsNonAuth(
    params: IPostOperationLogsNonAuthParameters
  ) {
    const api = new API();
    await api.post(
      `/users/executor/operation/logs`,
      {
        body: {
          operation_class: params.operation_class,
          option: {
            email: params.email,
          },
        },
      },
      false
    );
  }

  @Action({ rawError: true })
  public async fetchOperationLogs(
    params: IGetOperationLogsParameters
  ): Promise<void> {
    const api = new API();
    const response: OperationLogsGetResponse = await api.get(
      `/users/${params.user_id}/operation/logs`,
      {
        target_year_month: params.target_year_month,
      }
    );
    const logs: IOperationLogsState[] = [];
    if (response.logs) {
      response.logs.forEach((log: any) => {
        if (
          log &&
          log.timestamp &&
          log.last_name &&
          log.first_name &&
          log.screen_name &&
          log.operation_name
        ) {
          try {
            const timestamp = Utils.getApiResponseFormatDate(
              new Date(log.timestamp)
            );
            if (timestamp) {
              const user_name = `${log.last_name} ${log.first_name}`;
              const screen_name = log.screen_name;
              const operation_name = log.operation_name;
              logs.push({
                timestamp,
                user_name,
                screen_name,
                operation_name,
              });
            }
          } catch (e) {
            console.error(
              "操作ログ取得APIから取得した操作日時の変換に失敗しました。:",
              e
            );
          }
        }
      });
    }
    this.set(logs);
  }
}
